import { RequestService } from '../request';

import { ICreateTranscribeAnswer, ITranscribeAnswer } from './flashcard-practice.contract';

export class FlashcardPracticeService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async transcribeAnswer(
    createTranscribeAnswer: ICreateTranscribeAnswer
  ): Promise<ITranscribeAnswer> {
    const formData = new FormData();
    formData.append('file', createTranscribeAnswer.file, 'audio.webm');
    formData.append('language', createTranscribeAnswer.language);

    return this.poster<ITranscribeAnswer, FormData>('/flashcards-practice/transcription', formData);
  }
}
